import React, { useEffect } from 'react'

export default function GalleryLightboxModal({ photo, onClose }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [onClose])

  if (!photo) return null

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/85 backdrop-blur-sm animate-in fade-in duration-200"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative max-w-4xl max-h-[90vh] flex flex-col items-center overflow-hidden rounded-3xl bg-surface-container-lowest shadow-2xl border border-outline-variant/30"
      >
        {/* Close Button */}
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-black/60 text-white hover:bg-black transition cursor-pointer"
        >
          <span className="material-symbols-outlined text-xl">close</span>
        </button>

        {/* Photo */}
        <div className="overflow-hidden max-h-[75vh] w-full flex items-center justify-center bg-black">
          <img
            src={photo.imageUrl}
            alt={photo.caption}
            className="max-h-[75vh] w-full object-contain"
          />
        </div>

        {/* Caption & Metadata Footer */}
        <div className="w-full px-6 py-4 bg-surface-container-lowest border-t border-outline-variant/20 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <div>
            <h4 className="text-sm font-bold text-on-surface">{photo.caption}</h4>
            <p className="text-[11px] text-on-surface-variant">
              Uploaded on {photo.uploadedAt} • {photo.fileSize || 'Standard JPG'}
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 py-1.5 text-xs font-bold text-on-surface hover:bg-surface-container transition cursor-pointer self-start sm:self-auto"
          >
            Close Viewer
          </button>
        </div>
      </div>
    </div>
  )
}
